import Vue from 'vue';
import App from './Layout.vue';
import router from './router';
import store from './store';
import HighchartsVue from 'highcharts-vue';
import Highcharts from "highcharts";
import darkUnica from "highcharts/themes/dark-unica";
import * as VueGoogleMaps from "vue2-google-maps";
import VTooltip from 'v-tooltip';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vuelidate from 'vuelidate';
import VuejsClipper from 'vuejs-clipper'
import {ServerTable, ClientTable} from 'vue-tables-2';
// import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import VueMeta from 'vue-meta';

// import firebase from 'firebase/app';
import 'leaflet/dist/leaflet.css';
import fcmConfig from '@/config/fcm';
import helpersMixin from '@/util/mixins/helpers';

// import './registerServiceWorker'

// cropper
// Vue.component(VueCropper);
Vue.use(VuejsClipper, {
    components: {
        clipperBasic: true,
        clipperPreview: true
    },
})

darkUnica(Highcharts);
Vue.use(HighchartsVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAP_API_KEY,
    libraries: ["places", "visualization"] // necessary for places input
  }
});

Vue.use(VTooltip);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(fcmConfig);
//
// Vue.use(ClientTable, [options = {}], [useVuex = false], [theme = 'bootstrap3'], [swappables = {}]);
Vue.use(ClientTable, {}, false, 'bootstrap4', 'default')
Vue.use(ServerTable, {}, false, 'bootstrap4', 'default')

Vue.use(VueMeta);

Vue.mixin(helpersMixin);

Vue.config.productionTip = false;

window.EventEmit = new Vue();

// filter size global
if (store.state.record_size === null)
  store.state.record_size = store.getters.getDefaultRecordSize;

// filter date global
if (store.state.from_date === null)
  store.state.from_date = store.getters.getDefaultDate().from_date;

if (store.state.end_date === null)
  store.state.end_date = store.getters.getDefaultDate().end_date;

// filter date per menu
if (store.state.from_date_recent_location === null)
  store.state.from_date_recent_location = store.getters.getDefaultDate().from_date;
if (store.state.end_date_recent_location === null)
  store.state.end_date_recent_location = store.getters.getDefaultDate().end_date;

if (store.state.from_date_application_usage === null)
  store.state.from_date_application_usage = store.getters.getDefaultDate().from_date;
if (store.state.end_date_application_usage === null)
  store.state.end_date_application_usage = store.getters.getDefaultDate().end_date;

if (store.state.from_date_history_location === null)
  store.state.from_date_history_location = store.getters.getDefaultDate().from_date;
if (store.state.end_date_history_location === null)
  store.state.end_date_history_location = store.getters.getDefaultDate().end_date;

if (store.state.from_date_history_browsing === null)
  store.state.from_date_history_browsing = store.getters.getDefaultDate().from_date;
if (store.state.end_date_history_browsing === null)
  store.state.end_date_history_browsing = store.getters.getDefaultDate().end_date;

if (store.state.from_date_device_history === null)
  store.state.from_date_device_history = store.getters.getDefaultDate(89).from_date;
if (store.state.end_date_device_history === null)
  store.state.end_date_device_history = store.getters.getDefaultDate().end_date;

if (store.state.from_date_tethered_devices === null)
  store.state.from_date_tethered_devices = store.getters.getDefaultDate(89).from_date;
if (store.state.end_date_tethered_devices === null)
  store.state.end_date_tethered_devices = store.getters.getDefaultDate().end_date;

if (store.state.from_date_possible_location === null)
  store.state.from_date_possible_location = store.getters.getDefaultDate().from_date;
if (store.state.end_date_possible_location === null)
  store.state.end_date_possible_location = store.getters.getDefaultDate().end_date;

if (store.state.from_date_aerial_log === null)
  store.state.from_date_aerial_log = store.getters.getDefaultDate().from_date;
if (store.state.from_date_aerial_log === null)
  store.state.end_date_aerial_log = store.getters.getDefaultDate().end_date;

if (store.state.from_date_signal_status === null)
  store.state.from_date_signal_status = store.getters.getDefaultDate().from_date;
if (store.state.end_date_signal_status === null)
  store.state.end_date_signal_status = store.getters.getDefaultDate().end_date;

// local auth
router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        // if (localStorage.getItem('local_auth_token') === null) {
        // if (localStorage.getItem('auth_token') === null) {
        if (store.state.auth_token === null) {
            next({
                path: '/login',
                // params: { nextUrl: to.fullPath }
            })
        } else {
            // with local auth
            // if (localStorage.getItem('local_auth_token') === process.env.VUE_APP_LOCAL_AUTH_TOKEN) {
            //     next();
            // } else {

            //     localStorage.removeItem('local_auth_token');
            //     next({
            //         path: '/login',
            //         // params: { nextUrl: to.fullPath }
            //     });
            // }

            // with auth token
            // if (localStorage.getItem('auth_token')) {
            if (store.state.auth_token) {

              // check if astro is true
              if (process.env.VUE_APP_ASTRO === 'true') {
                switch(to.path) {
                  case '/media':
                    next('/errors/forbidden');
                    break;
                  case '/search-by-name':
                    next('/errors/forbidden');
                    break;
                  case '/clients':
                    next('/errors/forbidden');
                    break;
                  case '/clients/create':
                    next('/errors/forbidden');
                    break;
                  default:
                    next();
                }
              } else {
                next();
              }

            } else {

                // localStorage.removeItem('auth_token');
                store.state.auth_token = null;
                next({
                    path: '/login',
                    // params: { nextUrl: to.fullPath }
                });
            }
        }
    } else {
        // console.log('============ in reouter before each');
        // console.log(to.name);
        // console.log(to);
        // console.log(localStorage.getItem('local_auth_token'));

        // if (localStorage.getItem('local_auth_token') !== null && (to.name === 'pageLogin' || to.name === 'pageForgotPassword' || to.name === 'pageResetPassword')) {
        // if (localStorage.getItem('auth_token') !== null && (to.name === 'pageLogin' || to.name === 'pageForgotPassword' || to.name === 'pageResetPassword')) {
        if (store.state.auth_token !== null && (to.name === 'pageLogin' || to.name === 'pageForgotPassword' || to.name === 'pageResetPassword')) {
          next({
              path: '/',
              // params: { nextUrl: to.fullPath }
          });
        } else {
          next();
        }
    }
});

new Vue({
  // data: {
  //     error: "",
  //     errorEl: null,
  //     error2: "",
  //     err: false,
  //     vm: null,
  //     info: null,
  // },
  // errorCaptured: function(err, vm, info) {
  //     var _self = this;
  //     _self.err = err;
  //     _self.vm = vm;
  //     _self.info = info;
  //     _self.error2 = `${err.stack}\n\nfound in ${info} of component`
  //     _self.error = err.toString() || "Unexpected error has occured!";
  //     setTimeout(function() {
  //         _self.errorEl = vm.$el;
  //         if (!_self.errorEl || _self.errorEl.nodeName=="#comment")
  //             _self.errorEl = vm.$parent.$el;
  //         _self.errorEl.classList.add("error-frame");
  //     }, 0)
  // },
  // methods: {
  //     removeError: function() {
  //         if (!this.error)
  //             return;
  //         this.error = "";
  //         this.errorEl.classList.remove("error-frame");
  //         this.errorEl = null;
  //     }
  // },
  router,
  store,
  render: h => h(App),
  components: { App }
}).$mount('#app')

